import axios from 'axios';

const Axios = axios.create({
    baseURL: "https://penghapusan.bapenda.jabarprov.go.id",
    headers: {
      'Content-Type': 'application/json',
    }
  });

  export function prosesPenghapusan(params) {
    try {
      return Axios.post('/api/process', {
        ...params,
      });
    } catch (error) {
      console.error(error);
    }
  }

  export async function getVisitor() {
    try {
      return await Axios.get("/api/number-of-visitor");
    } catch (error) {
      console.error(error);
    }
  }
  
  export async function getDetailKBM(params) {
    try {
      return await Axios.get("/api/get-detail/"+params.id);
    } catch (error) {
      console.error(error);
    }
  }

  export async function getPDF(params) {
    try {
      return await Axios.get("/api/download/"+params.id);
    } catch (error) {
      console.error(error);
    }
  }